import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";

export const RefreshButton = () => {
  const isSmallScreen = useIsSmallScreen();

  const refreshHandler = () => {
    window.location.reload();
  };

  return (
    <>
      {isSmallScreen && (
        <div onClick={refreshHandler} className="menu-item">
          refresh
        </div>
      )}
    </>
  );
};
